import React from "react";
import pClasses from "../InfosLabels.module.scss";

const InfoLabel = ({ className = "", text = "", bold = false, icon = "" }) => {
  const textContent = bold ? <strong>{text}</strong> : text;
  return (
    <div className={className + " " + pClasses.InfoLabel}>
      <p>
        {icon}
        {textContent}
      </p>
    </div>
  );
};

export default InfoLabel;
